import { useState } from "react";
import classNames from "classnames";

import IconArrowGreen from "assets/svg/chevron_right_green.svg";

import CheckBoxItem from "src/components/common/checkbox-item";

import styles from "./styles.module.css";
import PropTypes from "prop-types";

const PoiFilterBox = ({ poiList, handleChangePoi, activeMapType }) => {
  const [seeMore, setSeeMore] = useState(true);

  const poiLocationBoxWrapper = classNames({
    [styles.poiLocationBoxWrapper]: true,
    [styles.seeMore]: seeMore,
    [styles.poiBoxView]: !["ROAD_VIEW", "SATELLITE_VIEW"]?.includes(activeMapType),
  });

  const iconClass = classNames({
    [styles.icon]: true,
    [styles.iconRotate]: seeMore,
  });

  const handleSeeMore = () => {
    setSeeMore(!seeMore);
  };

  return (
    <div className={poiLocationBoxWrapper}>
      <div className={styles.poiWrapper}>
        <p className={styles.poiBoxTitle}>Konum Bilgisi</p>
        {poiList?.slice(0, seeMore ? 5 : poiList.length).map((poiItem, index) => {
          const { categoryName, categoryId, poies } = poiItem || {};
          const totalPoiLength = poies?.length?.toString();
          return (
            <div key={index} className={styles.poiBox}>
              <CheckBoxItem
                title={categoryName}
                onChange={(e) => handleChangePoi(e, poiItem)}
                checkBoxClass={styles.checkBoxClass}
                displayClass={styles.displayClass}
                showCheckBoxFooter
                showImage
                name={categoryId}
                checkBoxLength={totalPoiLength}
              />
            </div>
          );
        })}
      </div>
      <button className={styles.buttonClass} onClick={handleSeeMore}>
        {seeMore ? <span>Daha Fazla Gör</span> : <span>Daha Az Gör</span>}
        <span className={iconClass}>
          <IconArrowGreen />
        </span>
      </button>
    </div>
  );
};

PoiFilterBox.propTypes = {
  poiList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  handleChangePoi: PropTypes.func.isRequired,
  activeMapType: PropTypes.bool,
};

export default PoiFilterBox;
